import { IImageMedia } from 'modules/common/interfaces';
import { IContacts } from './contacts';

export enum ClientType {
  STRUCTURE = 'STRUCTURE',
  ESTABLISHMENT = 'ESTABLISHMENT',
}

export interface IClient {
  _id?: string;
  name: string;
  active: boolean;
  contact: IContacts;
  createdAt?: Date;
  type: ClientType;
  avatar?: IImageMedia;
  description?: string;
}
